export const enum SEND_MESSAGE_TYPE {
  SINGLE = "Single",
  MULTI = "Multi",
  ALL = "All",
}

export const enum USER_LIST_COMPONENT_TYPE {
  USERS = "Users",
  GROUPS = "Groups",
}

export const USER_NOTES = "USER_NOTES";
export const GAMING_HISTORY = "GAMING_HISTORY";

export const enum GAME_TYPE {
  SPINNER = "SPINNER",
  SCRATCH_CARD = "SCRATCH_CARD",
}

export const enum SEGMENT_TYPE {
  PRIZE = "PRIZE",
  NO_WIN = "NO_WIN",
}

export const enum PLAY_FREQUENCY {
  ONCE = "ONCE",
  HOURLY = "HOURLY",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

export interface GamingSegment {
  id: string;
  type: SEGMENT_TYPE;
  display_text: string;
  color: string;
  image_url?: string;
  gift_description?: string;
  quantity_available?: number | null;
  quantity_used?: number;
  probability?: number;
}

export interface GamingConfiguration {
  enabled: boolean;
  game_type: GAME_TYPE;
  version: number;
  play_frequency: PLAY_FREQUENCY;
  segments: GamingSegment[];
  description?: string;
}

export interface GameHistoryRecord {
  played_at: string;
  result: "WIN" | "LOSE";
  segment_id: string;
  prize_applied: boolean;
  prize_details?: {
    display_text?: string;
    description?: string;
  } | null;
}

export interface PlayGameResult {
  success: boolean;
  result?: "WIN" | "LOSE";
  segment?: {
    id: string;
    display_text: string;
    color: string;
    type: SEGMENT_TYPE;
  };
  prize?: {
    display_text?: string;
    description?: string;
  };
  prize_applied?: boolean;
  error?: string;
  nextPlayAt?: string;
}

export interface CanPlayResult {
  canPlay: boolean;
  reason?: string;
  nextPlayAt?: string;
}

export type PromotionIntervalUnit = "hour" | "day" | "week" | "month" | "year";

/** Hours "HH:MM" in the entity's time zone, days from 1 (Monday) to 7 (Sunday). */
export interface AutoPilotSendWindow {
  start: string;
  end: string;
  days: number[];
}

export interface AutoPilotConfiguration {
  enabled: boolean;
  description: string;
  promotional_messages: string[];
  allow_promotion: boolean;
  promotion_messages: string[];
  promotion_interval_value?: number;
  promotion_interval_unit?: PromotionIntervalUnit;
  send_window?: AutoPilotSendWindow;
  language?: string;
}
